import Signals from "@/signals/GameSignals";
import Facade from "@/Facade";

export default class AdapterForJets {
    bet1 = 0;
    bet2 = 0;

    constructor(manager) {
        this.BALANCE_MULTIPLIER = 100
        this.manager = manager
        this.init()

        this.isInfoShown = false
    }

    init() {
        this.audioValue = true

        if (Facade.urlParams)
            this.onRelaxConfigure(Facade.urlParams)
        else
            Signals.urlSettings.add(this.onRelaxConfigure, this)

        Signals.loadingProgress.add(this.onLoadProgress, this)
        Signals.mainGameAssetsLoadingComplete.add(this.onLoadCompleted, this)

        Signals.setMakeBet.add(this.betReset, this)
        Signals.setBetStatus.add(this.betPlaced, this)


        Signals.muteAll.add(this.onAudioToggle, this)
        Signals.roundStart.add(this.onRoundStart, this)
        Signals.roundEnd.add(this.onRoundEnd, this)
        Signals.startFeature?.add(this.onStartFeature, this)
        Signals.stopFeature?.add(this.onStopFeature, this)
        Signals.balanceUpdate.add(this.onBalanceUpdate, this)
        Signals.modelInitStored.add(this.onModelInitStored, this)
        Signals.autoBetButtonClicked.add(this.onAutoPlayStarted, this)
        Signals.onWin.add(this.onWinUpdate, this)
        Signals.errorMessage.add(this.errorMessage, this)
        Signals.onClose && Signals.onClose.add(this.onClosed, this)
        Signals.gameMessage && Signals.gameMessage.add(this.onReload, this)

    }


    betReset(position) {
        if (position === 1) this.bet1 = 0;
        else if (position === 2) this.bet2 = 0;

        this.manager.betUpdate(this.toCents(this.bet1 + this.bet2))
    }

    betPlaced(data) {
        const betValue = data.ps.b;
        if (data.side === 1) {
            this.bet1 = betValue
        } else if (data.side === 2) {
            this.bet2 = betValue;
        }

        this.manager.betUpdate(this.toCents(this.bet1 + this.bet2))
    }

    // region #RECEIVED MESSAGES
    updateBalance(value, bonusBalance = undefined) {
        if (!value) {
            value = Facade.model.balance
        }
        Facade.model.balance = value
        if (bonusBalance !== undefined) {
            Facade.model.bonusBalance = bonusBalance
        }
    }

    stopAutospins() {
        Facade.model.setAutoBet1 = 0
        Facade.model.setAutoBet2 = 0
        Facade.model.setAutoCollect1 = 0
        Facade.model.setAutoCollect2 = 0

        Signals.autoBetButtonClicked.dispatch()
    }

    disableGamePopups() {
        Signals.disableGamePopups.dispatch();
    }

    enableGamePopups() {
        Signals.enableGamePopups.dispatch();
    }


    setAudio(value) {
        Signals.muteAll.dispatch(value)

        document.dispatchEvent(new CustomEvent("setButtonState", {
            detail: {
                sounds_STATE: {
                    state: value,
                }
            }
        }))
    }

    showHelp() {
        if (this.isInfoVisible()) {
            document.dispatchEvent(new CustomEvent('showinfo', {detail: {value: false}}))
        } else {
            document.dispatchEvent(new CustomEvent('showinfo', {detail: {value: true}}))
        }
    }

    togglePaytable() {
        if (this.isInfoVisible()) {
            document.dispatchEvent(new CustomEvent('showinfo', {detail: {value: false}}))
        } else {
            document.dispatchEvent(new CustomEvent('showinfo', {detail: {value: true}}))
        }
    }

    freeze() {
        document.dispatchEvent(new CustomEvent('tap', {detail: {name: "cancel1_BUTTON"}}))
        document.dispatchEvent(new CustomEvent('tap', {detail: {name: "cancel2_BUTTON"}}))
        this.disableAllUI()
    }

    unfreeze() {
        this.enableAll()
    }

    updateSettings(newSetting) {
        if (newSetting?.sounds !== undefined) {
            this.setAudio(newSetting.sounds)
        }
    }

    onStartFeature() {
        this.manager.featureStart()
    }

    onStopFeature() {
        this.manager.featureFinish()
    }

    quitHandler() {
        let hasToken = false
        if (Facade && Facade.hasToken)
            hasToken = Facade.hasToken()

        Signals.gameMessage?.dispatch('terminate')
        if (Facade.model.lobbyURL && !hasToken) {
            // There is window.top instead of window.location to ignore the iframe by puprose
            // window.top.location.replace(Facade.model.lobbyURL)
            window.open(Facade.model.lobbyURL, '_top');
        }
    }

    realityCheckPopup() {
        Signals.realityCheck.dispatch()
    }

    // endregion

    // region #SEND MESSAGES
    onRelaxConfigure(data) {
        this.manager.relaxConfigure(data)
    }

    onModelInitStored() {
        Facade.model.operatorHandlesErrors = this.manager.operatorHandlesErrors
    }

    onLoadProgress(data) {
        this.manager.loadProgress(data);
    }

    onLoadCompleted() {
        const audioState = this.audioValue;

        this.manager.loadCompleted();
        this.manager.audioToggle(audioState);
    }

    onAudioToggle(value) {
        this.audioValue = value
        this.manager.audioToggle(value);
    }

    onRoundStart() {
        const totalBet = (Facade.model.playerState1.b + Facade.model.playerState2.b);
        this.manager.roundStart(this.toCents(Facade.model.balance))
    }

    onRoundEnd() {
        const totalBet = (Facade.model.currentBet1 * 100000000 + Facade.model.currentBet2 * 100000000) / 100000000
        this.manager.roundEnd({
            balance: this.toCents(Facade.model.balance),
            totalBet: this.toCents(totalBet),
            totalWin: this.toCents(Facade.model.totalWin),
        });
        this.manager.winUpdate(this.toCents(Facade.model.totalWin))
    }

    onAutoPlayStarted() {
        if (Facade.model.autoBet1 || Facade.model.autoBet2)
            this.manager.autoPlayStarted()
        else if (!(Facade.model.autoBet1 && Facade.model.autoBet2)) {
            this.manager.autoplayFinished()
        }
    }

    onAutoplayFinished() {
        if (!(Facade.model.autoBet1 && Facade.model.autoBet2)) {
            this.manager.autoplayFinished()
        }
    }

    onBetUpdate(data) {
        const totalBet = (Facade.model.currentBet1 * 100000000 + Facade.model.currentBet2 * 100000000) / 100000000
        this.manager.betUpdate(this.toCents(totalBet))

    }

    onStakeUpdate(data) {
        const totalBet = (Facade.model.currentBet1 * 100000000 + Facade.model.currentBet2 * 100000000) / 100000000
        this.manager.stakeUpdate(totalBet)
    }

    onWinUpdate() {
        this.manager.winUpdate(this.toCents(Facade.model.totalWin))
        this.onBalanceUpdate()
    }

    onBalanceUpdate(value) {
        // Be careful. The value in the JETs with currency sign. For instance "$100"
        this.manager.balanceUpdate(this.toCents(Facade.model.balance), this.toCents(Facade.model.bonusBalance))
    }

    onReload(data) {
        if (data === 'terminate' && performance.getEntriesByType("navigation")[0].type !== "navigate") {
            this.manager.gameReload && this.manager.gameReload()
        }
    }

    onClosed() {
        if (Facade.urlParams.customer === "relax" || Facade.urlParams.customer === "betfair" || Facade.urlParams.customer === "onextwo") {
            this.manager.closed()
			return;
        } else if (!!Facade.model.lobbyURL) {
            window.open(Facade.model.lobbyURL, '_top');
			return;
		}
        else if(!!Facade.default.model.lobbyURL){
            window.open(Facade.default.model.lobbyURL, '_top');
			return;
        }

		location.reload();
    }

    errorMessage(data) {
        if (Facade.urlParams.customer === 'onextwo') {
            const errObj = {
                errorMessage: data.msg,
                errorCode: data.code,
                errorType: data.type,
            }

            if (errObj.errorCode > 1000) {
                errObj.errorCode = -Math.abs(errObj.errorCode - 1000);
                this.manager.errorMessage(errObj);
            }
            return;
        } else if (Facade.urlParams.customer === 'betfair_test' || Facade.urlParams.customer === 'betfair') {
            this.manager.errorMessage({
                message: data.msg.msg,
                title: data.type
            })
            return;
        }

        // Perhaps it is message about the unavailable to cancel freebet
        const params = data.params ? data.params : data
        if (params.message === 'info_message1_text')
            return;

        const message = {
            errorCode: '8501',
            errorMessage: params.message
        };

        this.manager.errorMessage(message);
    }

    // endregion

    // region #UI
    disableAllUI() {
        const event = new CustomEvent("enableUI", {detail: {value: false}})
        document.dispatchEvent(event)
    }

    enableAll() {
        const event = new CustomEvent("enableUI", {detail: {value: true}})
        document.dispatchEvent(event)
    }

    toCents(value) {
        return +(value) * this.BALANCE_MULTIPLIER
    }

    /** I have no choice.
     * There is no different way to understand that Info is visible now **/
    isInfoVisible() {
        const spans = document.querySelectorAll('span')
        const rtpSpan = Array.from(spans).find(e => e.textContent === 'RTP')
        return rtpSpan !== undefined
    }

    // endregion
}